import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  AccordionActions,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import classNames from 'classnames';

const styles = theme => ({
  expandIconLeft: {
    right: 8,
    left: 'unset',
    position: 'absolute',
    color: theme.palette.common.black,
  },
  root: {

  },
  contentHeader: {
    backgroundColor: `${theme.palette.grey[100]} !important`, //if you "focus" on the tab you get a dark grey background. You can do this by tabbing to it.
    fontSize: 18,
    height: 31,
    minHeight: 31,
    padding: '10px 15px',
    border: `1px solid ${theme.palette.grey[300]}`,
  },
  summaryContent: {
    margin: 'unset',
    minHeight: 'unset !important',
    display: 'flex',
    justifyContent: 'space-between',
    color: theme.palette.grey[800],
  },
  centerContent: {
    flexGrow: 1,
    padding: 0,
  },
  rightContent: {
    padding: 0,
    '&:last-child': {
      paddingRight: 0,
    },
  },
  shiftRight: {
    paddingRight: 12,
  },
  expandedSummary: {
    minHeight: 'unset !important',
    margin: 'unset !important',
  },
  noPadding: {
    padding: '0 0',
  },
  noBoxShadow: {
    boxShadow: 'none',
  },
  noMargin: {
    margin: '0 !important',
  },
});

class ExpansionPanel extends Component {
  render() {
    const {
      classes,
      title,
      hoverTitle,
      children,
      centerContent,
      rightcontent,
      customStyles,
      isTitleHiddenOnDetails,
      ...rest
    } = this.props;

    const useTitle = hoverTitle || title;

    return (
      <Accordion
        {...rest}
        title={useTitle}
        classes={{
          root: classNames(classes.noBoxShadow, customStyles && customStyles.root),
          expanded: classNames(classes.noBoxShadow, classes.noMargin, customStyles && customStyles.expanded),
        }}
      >
        <AccordionSummary
          classes={{
            root: classNames(classes.contentHeader, customStyles && customStyles.summary, rightcontent && classes.shiftRight),
            content: classes.summaryContent,
            expanded: classes.expandedSummary,
          }}
          expandIcon={<ExpandMoreIcon />}
          IconButtonProps={{
            classes: {
              root: classNames(classes.expandIconLeft, customStyles && customStyles.iconButton),
            },
          }}
        >
          {React.isValidElement(title) ? title : <span>{title}</span>}
          {centerContent && <AccordionActions classes={{ root: classes.centerContent }}>{centerContent}</AccordionActions>}
          {rightcontent && <AccordionActions classes={{ root: classes.rightContent }}>
            {rightcontent}
          </AccordionActions>}
        </AccordionSummary>
        <AccordionDetails classes={{ root: classes.noPadding }} title={isTitleHiddenOnDetails ? '' : useTitle}>
          {children}
        </AccordionDetails>
      </Accordion>
    );
  }
}

ExpansionPanel.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.object]),
};

export default withStyles(styles)(ExpansionPanel);
